import {
  Action,
  ActionType,
  IGetHolidayResponse,
} from "models/dashboard/holidayList";
import createReducer from "redux/createReducer";

export interface GetHolidayReducerType {
  loading: boolean;
  error?: string;
  holidayListResponse?: IGetHolidayResponse;
}

const defaultState: GetHolidayReducerType = {
  loading: false,
  error: undefined,
  holidayListResponse: undefined,
};

export const getHolidayReducer = createReducer<GetHolidayReducerType>(
  defaultState,
  {
    [ActionType.HOLIDAY_LIST](state: GetHolidayReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.HOLIDAY_LIST_ERROR](
      state: GetHolidayReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        holidayListResponse: undefined,
      };
    },

    [ActionType.HOLIDAY_LIST_SUCCESS](
      state: GetHolidayReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        holidayListResponse: action.payload,
      };
    },

    [ActionType.HOLIDAY_LIST_RESET](state: GetHolidayReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
      };
    },
  }
);
